<template>
  <div>
    <BrowserConstraintsInfoComponent v-if="sizeConstraintsBreached"
                                     :windowSizeAcceptable="!sizeConstraintsBreached"
                                     :window-constraints="windowConstraints"
                                     :window-dimensions="windowDimensions"
    />
    <!-- We use v-show instead of v-else to avoid the component being removed and re-added to DOM every time this happens-->
    <router-view v-show="!(sizeConstraintsBreached)"
                 @showCdss="showCdss"
                 @requestLogin="login"
                 @logout="logout"
                 :patientData="patientData"
    />
    <LoadingModalApp :show="showLoadingModalApp"></LoadingModalApp>
  </div>
</template>

<script>

import BrowserConstraintsInfoComponent from "./BrowserConstraintsInfoComponent";
import LoadingModalApp from "../../edith-app/src/components/LoadingModalApp.vue";
import {logout} from "./js/util";

export default {
  name: 'Root',
  components: {LoadingModalApp, BrowserConstraintsInfoComponent},
  data() {
    return {
      patientData: undefined,
      showLoadingModalApp: false,
      windowConstraints: {'minWidth': 1512, 'minHeight': 750},
      windowDimensions: {'width': undefined, 'height': undefined},
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    document.title = 'EDITH App'
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    sizeConstraintsBreached() {
      return this.windowDimensions.width < this.windowConstraints.minWidth ||
          this.windowDimensions.height < this.windowConstraints.minHeight
    },
  },
  methods: {
    login() {
      this.$router.push({
        name: "formular",
      })
    },
    showCdss(patientData) {
      this.patientData = patientData
      this.$router.push("/cdss/")
    },
    handleResize() {
      this.windowDimensions = {'width': window.innerWidth, 'height': window.innerHeight}
    },
    logout() {
      logout();
      this.$router.replace({name: "login"});
    }
  }
}
</script>

<style>
</style>
